'use client'

import { requestJson } from '@/lib/santa-chat/api'
import type {
  PublicChatMessageResult,
  PublicChatOpenResult,
} from '@/server/application/santa-chat/public/public-chat-contract'

const OPEN_PATH = '/api/santa-chat/public/open'
const MESSAGES_PATH = '/api/santa-chat/public/messages'

/** La sesión del token ya no vale (caducó a medianoche UTC, o está manipulado): reintentar no la arregla. */
export const INVALID_SESSION_CODE = 'PUBLIC_CHAT_INVALID_SESSION'

export interface OpenPublicChatBody {
  name: string | null
  locale: string
  turnstileToken: string | null
  /** La marca de este navegador (DD3): el día UTC en que ya abrió sesión, si lo hizo. */
  deviceUsedOn: string | null
}

function postJson<T>(path: string, body: Record<string, unknown>): Promise<T> {
  return requestJson<T>(path, { body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } })
}

/** Abre una sesión del chat público (el adulto ya confirmó: es la única forma de llegar aquí). */
export function openPublicChat(body: OpenPublicChatBody): Promise<PublicChatOpenResult> {
  return postJson(OPEN_PATH, { adultConfirmed: true, ...body })
}

export function sendPublicChat(token: string, text: string): Promise<PublicChatMessageResult> {
  return postJson(MESSAGES_PATH, { token, text })
}
